// Browser: read from the __PUBLIC_ENV__ script tag injected by server.utils.js.
// Server (Node.js): read from process.env directly.
let _envCache;
function getEnv(key) {
  if (typeof document !== "undefined" && !_envCache) {
    try {
      const el = document.getElementById("__PUBLIC_ENV__");
      if (el) _envCache = JSON.parse(el.textContent);
    } catch (_) {}
  }
  return (_envCache && _envCache[key]) ?? process.env[key];
}

function getStatsigEnvironment() {
  const clusterId = getEnv("CLUSTER_ID");
  if (clusterId === "alpha") return "development";
  if (clusterId === "beta") return "staging";
  if (clusterId === "prod") return "production";
  return "development";
}

const UNSAFE_CLIENT_EXPOSED_PUBLIC_CONFIG = {
  branch_sdk_key: getEnv("BRANCH_SDK_KEY"),
  DATADOG_RUM_APPLICATION_ID: getEnv("DATADOG_RUM_APPLICATION_ID"),
  DATADOG_RUM_CLIENT_TOKEN: getEnv("DATADOG_RUM_CLIENT_TOKEN"),
  env_handshake: getEnv("HANDSHAKE_ENV"),
  external_address: getEnv("EXTERNAL_ADDRESS") || "",
  forter_key: getEnv("FORTER_KEY") ?? getEnv("FORTER_SNIPPET_KEY"),
  google_maps_browser_key: getEnv("GOOGLE_MAPS_BROWSER_KEY"),
  hideReferral: false,
  intercom_app_id: getEnv("INTERCOM_APP_ID") || "ioz1lfrt",
  PS_ENV: getEnv("PS_ENV") || "development",
  RELEASE_TAG: getEnv("RELEASE_TAG") || "latest",
  segment_io_api_key: getEnv("SEGMENT_IO_API_KEY"),
  segment_custom_domain: getEnv("SEGMENT_CUSTOM_DOMAIN") || "beta-e.peerspaceapp.com",
  statsig_sdk_key:
    getEnv("STATSIG_SDK_KEY") ||
    "client-MI9UJ1EGqbff6t1PmR0kpAyidq4AyEL7haCn2PlWZXO",
  statsig_environment: getStatsigEnvironment(),
};

export default UNSAFE_CLIENT_EXPOSED_PUBLIC_CONFIG;
